/* eslint @typescript-eslint/ban-ts-comment: 0*/
import { Box } from '@mui/material';
import { forwardRef } from 'react';
import type { ScrollBarProps as PerfectScrollbarProps } from 'react-perfect-scrollbar';
import PerfectScrollbar from 'react-perfect-scrollbar';

const Scrollbar = forwardRef<HTMLDivElement, PerfectScrollbarProps>((props, ref) => {
    const { children, ...other } = props;

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (isMobile) {
        return (
            <Box ref={ ref } sx={ { overflowX: 'auto' } }>
                { children }
            </Box>
        );
    }

    return (
        <PerfectScrollbar
            // @ts-ignore
            ref={ ref } { ...other }>
            { children }
        </PerfectScrollbar>
    );
});

Scrollbar.displayName = 'Scrollbar';

export default Scrollbar;
